import React, { Fragment } from 'react';
import { gql } from 'apollo-boost';
import { Query } from 'react-apollo';

export const getBeerStylesQuery = gql`
  query beerStyles {
    beerStyles {
      id
      name
    }
  }
`;

const BeerStyleOptions = ({ brewery }) => (
  <Query query={getBeerStylesQuery}>
    {props => {
      const { loading, error, data } = props;
      if (loading) {
        return <option>...</option>;
      }

      if (error) {
        return <option>Sorry, there was an error getting the beer styles</option>;
      }

      return (
        <Fragment>
          <option>Select a style</option>
          {data.beerStyles.map(style => (
            <option key={style.id} value={style.id}>
              {style.name}
            </option>
          ))}
        </Fragment>
      );
    }}
  </Query>
);

export default BeerStyleOptions;



// WEBPACK FOOTER //
// ./src/containers/beerStyleOptions/beerStyleOptions.jsx